"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    ul: {
      listStyle: 'none',
      margin: 0,
      display: 'inline-flex',
      backgroundColor: theme.palette.NEUTRAL000,
      boxShadow: theme.shadows[1],
      padding: theme.spacing(0.5),
      borderRadius: 4
    },
    button: {
      backgroundColor: theme.palette.NEUTRAL000,
      color: theme.palette.NEUTRAL700,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: theme.spacing(0, 0.2),
      fontSize: theme.typography.pxToRem(14),
      borderRadius: 4,
      border: 'none',
      width: 32,
      height: 32,
      cursor: 'pointer',
      '&:focus': {
        outline: 'none'
      }
    },
    buttonSelected: {
      backgroundColor: theme.palette.BLUE400,
      color: theme.palette.NEUTRAL000,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightMedium
    },
    disabledButton: {
      color: theme.palette.NEUTRAL050,
      cursor: 'default'
    }
  });
});
var _default = useStyles;
exports.default = _default;